/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NameInputs */

const th_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ`)
};

const en_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ja_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

const zh_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const es_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const pt_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const id_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const fr_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const tl_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan`)
};

const vi_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên`)
};

const ko_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름`)
};

const de_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ru_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя`)
};

const tr_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad`)
};

const it_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const pl_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię`)
};

const uk_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ім'я`)
};

const hi_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const ar_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم`)
};

const ms_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const bn_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নাম`)
};

const zh_tw2_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const zh_hk2_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ur_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام`)
};

const fa_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام`)
};

const sw_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina`)
};

const nl_name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {NameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const name = /** @type {((inputs?: NameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_name(inputs)
	if (locale === "ja") return ja_name(inputs)
	if (locale === "zh") return zh_name(inputs)
	if (locale === "es") return es_name(inputs)
	if (locale === "pt") return pt_name(inputs)
	if (locale === "id") return id_name(inputs)
	if (locale === "fr") return fr_name(inputs)
	if (locale === "tl") return tl_name(inputs)
	if (locale === "vi") return vi_name(inputs)
	if (locale === "ko") return ko_name(inputs)
	if (locale === "de") return de_name(inputs)
	if (locale === "ru") return ru_name(inputs)
	if (locale === "tr") return tr_name(inputs)
	if (locale === "it") return it_name(inputs)
	if (locale === "pl") return pl_name(inputs)
	if (locale === "uk") return uk_name(inputs)
	if (locale === "hi") return hi_name(inputs)
	if (locale === "ar") return ar_name(inputs)
	if (locale === "ms") return ms_name(inputs)
	if (locale === "bn") return bn_name(inputs)
	if (locale === "zh-TW") return zh_tw2_name(inputs)
	if (locale === "zh-HK") return zh_hk2_name(inputs)
	if (locale === "ur") return ur_name(inputs)
	if (locale === "fa") return fa_name(inputs)
	if (locale === "sw") return sw_name(inputs)
	if (locale === "nl") return nl_name(inputs)
	return en_name(inputs)
});